import './module/_jquery.js'
import './module/_jquery.validationEngine-ja.js'
import './module/_jquery.validationEngine.js'

contact()
function contact() {
  /*
   ###          ##    ###    ##     ##
 ##   ##        ##  ##   ##    ## ##
##     ##       ## ##     ##    ###
######### ##    ## #########   ## ##
##     ##  ######  ##     ## ##     ##
*/
  let ajax = false // Ajaxリクエスト
  let ajaxResponse = '' // 最後のレスポンスを格納する

  /*
         ########  #######  ########  ##     ##
         ##       ##     ## ##     ## #### ####
 ####### ######   ##     ## ########  ## ### ##
         ##       ##     ## ##   ##   ##     ##
         ##        #######  ##     ## ##     ##

フォーム送信して結果を反映する
buttonのdata-form属性と同じnameのform内の入力を取得、formaction属性のURLに送信する

<form action="hoge.php" method="POST" name="form-name">
  <button type="button" formaction="hoge.php"  class="js-contactAjax" data-form="form-name" data-input="type,item" data-from="#list" data-to="#list" data-push="on">
      更新
  </button>
</form>

*/

  if (document.getElementsByClassName('js-contactAjax')[0]) {
    window.addEventListener('click', (e) => {
      if (e.target.classList.contains('js-contactAjax') && e.target.tagName === 'BUTTON') {
        e.preventDefault()
        ajaxSubmit(e.target)
      }
    })
  }
  if (document.getElementsByClassName('js-contactAjax')[0]) {
    window.addEventListener('change', (e) => {
      if (e.target.classList.contains('js-contactAjax')) {
        e.preventDefault()
        ajaxSubmit(e.target)
      }
    })
  }

  function ajaxSubmit(item) {
    let param = '' // 送信パラメータ
    const name = item.dataset.form
    const form = document.forms[name] // 指定nameのformに存在するinputにアクセス
    const url = item.formAction // 取得先

    const method = form.method // GET/POST

    const type = item.dataset.type // add(追加)もしくはrep(差し替え)
    const from = item.dataset.from // 取得要素
    const to = item.dataset.to // 差し替え要素
    const pushSt = item.dataset.push // URLのプッシュ
    const scroll = item.dataset.scroll // スクロール先

    if (item.name && item.value) {
      // クリックしたボタンの値を取り込む
      param += item.name + '=' + encodeURIComponent(item.value)
    }

    // 指定されているinputを取得して送信データ化する
    const inputList = form.querySelectorAll('input,textarea,select')

    for (const input of inputList) {
      if ((input.type === 'checkbox' || input.type === 'radio') && !input.checked) {
        // 未チェックのチェックは飛ばす
        continue
      }
      if (param !== '') {
        param += '&'
      }
      param += input.name + '=' + encodeURIComponent(input.value)
    }

    // バリデーションを確認する
    const valCheck = $(item.closest('form')).validationEngine('validate')
    if (!valCheck) {
      return
    }

    // console.log(param)
    applyAjax(url, method, param, from, to, pushSt, type, scroll)
  }

  /*
           ###    ########  ########  ##       ##    ##
         ##   ##  ##     ## ##     ## ##         ####
####### ##     ## ########  ########  ##          ##
        ######### ##        ##        ##          ##
        ##     ## ##        ##        ########    ##
*/
  /**
   * Ajax処理を実行する
   * @param url {string} 取得先のURL
   * @param from {string} 書き換え元のセレクタ　,区切りで複数指定
   * @param to {string} 取得先のセレクタ　,区切りで複数指定
   * @param pushSt {string|boolean} 擬似的にページ遷移する　falseじゃなければ有効
   * @param type {string} rep:要素を書き換える add:書き換え元の下に追加する
   * @param scroll {string} 指定の位置にスクロールさせる
   * @param flag {string} 独自の拡張用
   */
  function applyAjax(url, method = 'get', param, from, to, pushSt, type = 'rep', scroll = false, flag = null) {
    from = from.split(',') // ,区切りで配列に変換
    to = to.split(',') // ,区切りで配列に変換

    const loadingItem = document.createElement('div')
    loadingItem.className = 'md-loading active'

    // ローディング処理
    for (let index = 0; index < to.length; index++) {
      const itemTo = document.querySelector(to[index])
      const loadingItem = document.createElement('div')
      loadingItem.className = 'md-loading active'
      if (type === 'rep') {
        loadingItem.style.width = itemTo.offsetWidth + 'px'
        loadingItem.style.height = itemTo.offsetHeight + 'px'
        itemTo.innerHTML = ''
      }
      itemTo.appendChild(loadingItem)
    }

    if (ajax) {
      // 既に通信中なら切断
      ajax.abort()
    }

    ajax = new XMLHttpRequest() // Ajaxリクエスト
    if (method === 'post') {
      ajax.open(method, url, true) // GET/POST, URL, 非同期処理
    } else {
      if (param) {
        url += (~url.indexOf('?') ? '&' : '?') + param // パラメータをURLに結合
      }
      if (pushSt === 'on') {
        history.pushState(null, null, url) // URL変更
      }
      // Ajaxと明示するパラメータを付ける
      url += (~url.indexOf('?') ? '&' : '?') + 'ajax=1'
      ajax.open(method, url, true) // GET/POST, URL, 非同期処理
    }
    ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest') // Ajaxでのアクセスと明示するリクエストヘッダー
    // キャッシュせず最新のデータを取る場合のリクエストヘッダー3種
    ajax.setRequestHeader('Pragma', 'no-cache')
    ajax.setRequestHeader('Cache-Control', 'no-cache')
    ajax.setRequestHeader('If-Modified-Since', 'Thu, 01 Jun 1970 00:00:00 GMT')
    if (method === 'post') {
      ajax.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded') // POST時に必要なリクエストヘッダー
    }
    ajax.responseType = 'document' // 取得タイプ document text json
    ajax.timeout = 10000 // タイムアウト判定時間
    if (method === 'post') {
      ajax.send(param) // POSTリクエスト実行
    } else {
      ajax.send() // GETリクエスト実行
    }
    ajax.onload = function () {
      // アクセス成功
      if (ajax.status < 200 || ajax.status >= 400) {
        console.log('Error: Code ' + ajax.status) // エラー
        return
      }

      ajaxResponse = ajax.response // 取得結果を更新

      let ajaxData = ajaxResponse // 実際に使用するデータ

      // // IEは取得タイプJSONをtextで受け取るのでJSONにパースする
      // if (navigator.userAgent.indexOf('Trident') !== -1 && JSON) {
      //   ajaxData = JSON.parse(ajaxData)
      // }
      for (let index = 0; index < to.length; index++) {
        const itemFrom = ajaxData.querySelector(from[index])
        const itemTo = document.querySelector(to[index])

        itemTo.innerHTML = itemFrom.innerHTML

        // intObs()
      }
      if (pushSt === 'on') {
        // Metaの更新
        document.head.querySelector('title').innerHTML = ajaxData.querySelector('title').innerHTML
        document.head.querySelector('meta[property="og:title"]').content =
          ajaxData.querySelector('meta[property="og:title"]').content
        document.head.querySelector('meta[property="og:url"]').content =
          ajaxData.querySelector('meta[property="og:url"]').content
      }

      if (scroll) {
        autoScroll(scroll, '#header', true)
      }

      window.setValidation() // バリデーション起動
      window.datePicker() // デートピッカー起動
    }
    ajax.ontimeout = function (e) {
      // タイムアウト
    }
    ajax.onerror = function () {
      // Ajax処理失敗
    }
    ajax.onloadend = function () {
      // 受信成否に関わらず実行
      // intObsAjax()
      ajax = false
    }
  }
}
